var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audiences-view',{staticClass:"scrollable",attrs:{"audiences":_vm.interests,"loaded":_vm.audienceLoadable.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }